<template>
  <div class="maintenance-overlay d-flex flex-column align-items-center justify-content-center text-center">
    <Loader />
    <h4 class="mt-4 mb-2">TalentFind is switching database</h4>
    <p class="mb-0">
      This takes under a minute - you'll then need to log in again.
    </p>
  </div>
</template>

<script>
import customer from "@/services/customer";

// How often to ask whether the admin DB switch (modules/dbSwitch.js) is over.
const POLL_MS = 10000;

export default {
  name: "MaintenanceOverlay",
  data() {
    return { timer: null };
  },
  mounted() {
    this.timer = setInterval(this.poll, POLL_MS);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    // Still 503 MAINTENANCE: keep waiting. 401 DB_SWITCHED: the interceptor is already logging
    // out. Anything else (200, or a 401/403 for someone not logged in) means the switch is over.
    poll() {
      customer
        .getUser("")
        .then(() => this.$store.dispatch("endDbSwitchMaintenance"))
        .catch((err) => {
          const { status, data } = err?.response || {};
          const code = data?.detail?.code;
          if (status === 503 && code === "MAINTENANCE") return;
          if (status === 401 && code === "DB_SWITCHED") return;
          if (!status) return; // network blip - try again
          this.$store.dispatch("endDbSwitchMaintenance");
        });
    },
  },
};
</script>

<style scoped>
.maintenance-overlay {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1000000; /* above LoadingOverlay */
  padding: 16px;
  background: rgba(255, 255, 255, 0.95);
}
</style>
